import React from 'react';
import Typography from '@mui/material/Typography';

interface IRowProps {
  hit: any;
}

const FedData: React.FC<IRowProps> = ({ hit }) => {
  return (
    <>
      <div className='hb-primary-col'>
        <Typography className='hb-primary-col-typo'>
          {hit._source['Control Name']}
        </Typography>
      </div>
      <div className='hb-primary-col'>
        <Typography className='hb-primary-col-typo'>
          {hit._source.Baseline}
        </Typography>
      </div>
      <div className='hb-primary-col'>
        <Typography className='hb-primary-col-typo'>
          {hit._source.Identification}
        </Typography>
      </div>
      <div className='hb-primary-col'>
        <Typography className='hb-primary-col-typo'>
          {hit._source.Family}
        </Typography>
      </div>
    </>
  );
};

export default FedData;
